import type {
  StepDownTransformersQueryVariables,
  Step_Down_Transformers_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function restoreStepDownTransformers(
  arr: Array<string>
): Step_Down_Transformers_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteStepDownTransformers(
  arr: Array<string>
): Step_Down_Transformers_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultDownTransVars: StepDownTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};

export const adminDownTransVars: StepDownTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};
export const kocDownTransVars: StepDownTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolDownTransVars: StepDownTransformersQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
